import React from "react";

import { Eyebrow, Title, ShieldIcon } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function CodeOfConductFaculty() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">
                
                {/* HERO */}
                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute inset-0 bg-[linear-gradient(115deg,#071A2F_0%,#071A2F_58%,#0C2744_58%,#0C2744_100%)]" />
                        <div className="absolute right-0 top-0 h-full w-[42%] opacity-[0.05] [background-image:linear-gradient(rgba(255,255,255,.7)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.7)_1px,transparent_1px)] [background-size:56px_56px]" />
                        <div className="absolute bottom-0 left-0 h-[5px] w-[32%] bg-[#8B1E3F]" />
                        <div className="absolute bottom-0 left-[32%] h-[5px] w-[14%] bg-[#D5AD57]" />
                    </div>

                    <div className="relative mx-auto grid min-h-[610px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.12fr_.88fr] pb-16 lg:pb-20">

                        {/* LEFT */}
                        <div className="flex flex-col justify-center pr-8 lg:pr-20">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                Faculty Code of Conduct
                            </div>

                            <h1 className="mt-8 max-w-[850px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(54px,6.5vw,94px)] font-normal leading-[0.95] tracking-[-0.045em]">
                                Professional conduct
                                <span className="block text-[#D5AD57]">
                                    with academic integrity.
                                </span>
                            </h1>

                            <p className="mt-8 max-w-[700px] text-[17px] leading-8 text-white/65">
                                The Faculty Code of Conduct defines the professional responsibilities expected from teachers of ISBM University in their academic duties, relationships with students and colleagues, institutional responsibilities, and contribution to society.
                            </p>

                            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-white/15 pt-7">

                                {[
                                    "Academic Integrity",
                                    "Professional Ethics",
                                    "Student Responsibility",
                                    "Institutional Commitment",
                                ].map((item) => (
                                    <div key={item} className="flex items-center gap-3">

                                        <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/65">
                                            {item}
                                        </span>

                                    </div>
                                ))}

                            </div>

                        </div>


                        {/* RIGHT */}
                        <div className="relative hidden border-l border-white/10 lg:block">

                            <span className="absolute right-[-10px] top-[-35px] font-['Libre_Caslon_Display',Georgia,serif] text-[260px] font-normal leading-none tracking-[-0.08em] text-white/[0.035]">
                                08
                            </span>

                            <div className="relative flex h-full flex-col justify-center px-10 xl:px-14">

                                <div className="flex items-center justify-between">

                                    <div className="grid h-16 w-16 place-items-center rounded-full border border-[#D5AD57]/40 text-[#D5AD57]">
                                        <ShieldIcon />
                                    </div>

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[58px] font-normal leading-none text-[#D5AD57]">
                                        08
                                    </span>

                                </div>

                                <span className="mt-8 text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                    Areas of Faculty Responsibility
                                </span>

                                <h2 className="mt-4 max-w-[440px] font-['Libre_Caslon_Display',Georgia,serif] text-[34px] font-normal leading-[1.15]">
                                    Standards covering every dimension of the teaching profession.
                                </h2>

                                <div className="mt-8 grid grid-cols-2 border-l border-t border-white/10">

                                    {[
                                        ["01", "Professional Responsibilities"],
                                        ["02", "Students"],
                                        ["03", "Colleagues"],
                                        ["04", "Authorities"],
                                        ["05", "Non-Teaching Employees"],
                                        ["06", "Guardians"],
                                        ["07", "Society"],
                                        ["08", "Additional Conduct"],
                                    ].map(([number, title]) => (
                                        <div key={number} className="border-b border-r border-white/10 px-4 py-4">

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[17px] text-[#D5AD57]">
                                                {number}
                                            </span>

                                            <p className="mt-2 text-[10px] font-semibold uppercase leading-5 tracking-[0.08em] text-white/55">
                                                {title}
                                            </p>

                                        </div>
                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* MOBILE RESPONSIBILITY STRIP */}
                    <div className="relative border-t border-white/10 lg:hidden">

                        <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] grid-cols-2 max-sm:w-[calc(100%-28px)] sm:grid-cols-4">

                            {[
                                ["01", "Professional"],
                                ["02", "Students"],
                                ["03", "Colleagues"],
                                ["04", "Authorities"],
                                ["05", "Non-Teaching"],
                                ["06", "Guardians"],
                                ["07", "Society"],
                                ["08", "Additional"],
                            ].map(([number, title]) => (
                                <div key={number} className="border-b border-r border-white/10 px-4 py-5">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[19px] text-[#D5AD57]">
                                        {number}
                                    </span>

                                    <span className="ml-3 text-[9px] font-bold uppercase tracking-[0.1em] text-white/65">
                                        {title}
                                    </span>

                                </div>
                            ))}

                        </div>

                    </div>

                </section>


                {/* FACULTY CODE CONTENT */}
                <section className="relative overflow-visible bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        {/* SECTION HEADER */}
                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_430px] lg:items-end">

                            <div>

                                <Eyebrow>Faculty Code of Conduct</Eyebrow>

                                <Title before="Professional Standards for" highlight="Academic Responsibility" after="" position="middle" theme="burgundy" />

                            </div>

                            <p className="text-[15px] leading-8 text-[#65727E]">
                                A framework guiding professional behaviour, academic responsibility,
                                collegial conduct, institutional cooperation and social responsibility
                                among faculty members.
                            </p>

                        </div>


                        {/* CONTENT GRID */}
                        <div className="mt-14 grid items-start gap-12 lg:grid-cols-[300px_minmax(0,1fr)] lg:gap-16">

                            {/* STICKY SIDEBAR */}
                            <div className="relative hidden h-full lg:block">

                                <aside className="sticky top-[145px]">

                                    <div className="border border-[#071A2F]/10 bg-white p-6">

                                        <div className="flex items-center justify-between border-b border-[#071A2F]/10 pb-5">

                                            <span className="text-[10px] font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">
                                                Faculty Responsibilities
                                            </span>

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] text-[#D5AD57]">
                                                08
                                            </span>

                                        </div>

                                        <nav className="mt-3">

                                            {[
                                                ["01", "Professional Responsibilities", "#professional"],
                                                ["02", "Teachers & Students", "#students"],
                                                ["03", "Teachers & Colleagues", "#colleagues"],
                                                ["04", "Teachers & Authorities", "#authorities"],
                                                ["05", "Non-Teaching Employees", "#non-teaching"],
                                                ["06", "Teachers & Guardians", "#guardians"],
                                                ["07", "Teachers & Society", "#society"],
                                                ["08", "Additional Conduct", "#additional"],
                                            ].map(([number, title, href]) => (
                                                <a key={number} href={href} className="group grid grid-cols-[36px_1fr_auto] items-center gap-3 border-b border-[#071A2F]/10 py-3.5 last:border-b-0">

                                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[18px] text-[#D5AD57]">
                                                        {number}
                                                    </span>

                                                    <span className="text-[12px] font-semibold leading-5 text-[#071A2F]/60 transition group-hover:text-[#8B1E3F]">
                                                        {title}
                                                    </span>

                                                    <span className="text-[#8B1E3F]/30 transition group-hover:translate-x-1 group-hover:text-[#8B1E3F]">
                                                        →
                                                    </span>

                                                </a>
                                            ))}

                                        </nav>

                                    </div>


                                    <div className="mt-5 bg-[#071A2F] p-6 text-white">

                                        <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                            Core Principle
                                        </span>

                                        <p className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.25]">
                                            Professional conduct reflects the dignity of the teaching profession.
                                        </p>

                                    </div>

                                </aside>

                            </div>


                            {/* MOBILE NAVIGATION */}
                            <div className="lg:hidden">

                                <div className="flex gap-2 overflow-x-auto pb-3">

                                    {[
                                        ["01", "#professional"],
                                        ["02", "#students"],
                                        ["03", "#colleagues"],
                                        ["04", "#authorities"],
                                        ["05", "#non-teaching"],
                                        ["06", "#guardians"],
                                        ["07", "#society"],
                                        ["08", "#additional"],
                                    ].map(([number, href]) => (
                                        <a key={number} href={href} className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#071A2F] font-['Libre_Caslon_Display',Georgia,serif] text-[16px] text-[#D5AD57]">
                                            {number}
                                        </a>
                                    ))}

                                </div>

                            </div>


                            {/* MAIN CONTENT */}
                            <div className="min-w-0 space-y-8">

                                {/* 01 */}
                                <article id="professional" className="scroll-mt-[140px] overflow-hidden border border-[#071A2F]/10 bg-white">

                                    <div className="grid md:grid-cols-[150px_1fr]">

                                        <div className="flex flex-col justify-between bg-[#071A2F] p-7 text-white">

                                            <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#D5AD57]">
                                                Faculty Code
                                            </span>

                                            <strong className="mt-16 font-['Libre_Caslon_Display',Georgia,serif] text-[72px] font-normal leading-none text-[#D5AD57]">
                                                01
                                            </strong>

                                        </div>


                                        <div className="p-7 sm:p-9 lg:p-10">

                                            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                Section A
                                            </span>

                                            <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[34px] font-normal leading-[1.1] text-[#071A2F]">
                                                The Teachers and Their Professional Responsibilities
                                            </h3>

                                            <p className="mt-6 text-[15px] leading-8 text-[#65727E]">
                                                Any person who takes teaching as a profession assumes the obligation to conduct
                                                himself/herself in accordance with the ideals of the profession. The teacher is
                                                constantly under the scrutiny of his/her students and the society at large.
                                            </p>

                                            <h4 className="mt-8 text-xs font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                                A teacher shall:
                                            </h4>

                                            <ol className="mt-6 grid gap-3">

                                                {[
                                                    "Adhere to a responsible pattern of conduct and demeanor expected of him/her by his/her peers and the community.",
                                                    "Prefer constructive, reflective, collaborative, integrative and enquiry-based approach and pedagogical tools for teaching-learning assignment.",
                                                    "Communicate effectively while facilitating students and other stakeholders and the preferably language is English.",
                                                    "Wear smart professional attire at the workplace preferably in decent formals.",
                                                    "Manage his/her private affairs in a manner consistent with the dignity of the profession.",
                                                    "Seek to make professional growth continuous through study, research, writing, and participating in seminar, workshops, symposia with decent conduct.",
                                                    "Express free and frank opinion by active participation at professional meetings, seminars, conferences, by contribution towards the contribution of knowledge.",
                                                    "Maintain active membership in professional organizations, subscribing to academic/subject periodicals, and strive to improve education and profession.",
                                                    "Perform his/her duties in the form of teaching, tutorial, practical and seminar work with dedication.",
                                                    "Co-operate and assist in carrying out functions relating to the educational responsibilities of the University such as: assisting and appraising applications for admission, advising and counselling students as well as assisting in the conduct of University examinations, including supervision, invigilation, and evaluation.",
                                                    "Participate in extension, co-curricular and extracurricular activities including community service.",
                                                    "Try to complete assigned task in timely manner less adhering to the deadlines assigned.",
                                                ].map((item, index) => (
                                                    <li key={index} className="grid grid-cols-[36px_1fr] gap-4 border-t border-[#071A2F]/10 py-4 first:border-t-0">

                                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[18px] text-[#D5AD57]">
                                                            {String(index + 1).padStart(2, "0")}
                                                        </span>

                                                        <span className="text-[14px] leading-7 text-[#52606C]">
                                                            {item}
                                                        </span>

                                                    </li>
                                                ))}

                                            </ol>

                                        </div>

                                    </div>

                                </article>


                                {/* 02 */}
                                <article id="students" className="scroll-mt-[140px] border border-[#071A2F]/10 bg-[#EEF4F8] p-7 sm:p-9 lg:p-10">

                                    <div className="flex items-start justify-between gap-6">

                                        <div>

                                            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                Section B
                                            </span>

                                            <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[34px] font-normal text-[#071A2F]">
                                                Teachers and the Students
                                            </h3>

                                        </div>

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[54px] text-[#D5AD57]">
                                            02
                                        </span>

                                    </div>

                                    <h4 className="mt-8 text-xs font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                        A teacher shall:
                                    </h4>

                                    <div className="mt-6 grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">

                                        {[
                                            "Respect the right and dignity of the student while expressing his/her opinion.",
                                            "Deal impartially with students regardless of their religion, caste, sex, political, economic, social, and physical status.",
                                            "Mark his/her attendance preferably within 10 minutes of the commencement of lecture and on the day of the class.",
                                            "Recognize the difference in aptitude and capabilities among students and strive to meet their academic needs.",
                                            "Encourage students to improve their attainments, develop their personalities and at the same time contributing to community welfare.",
                                            "Inculcate among students scientific, progressive, and rational outlook and respect for physical labour and ideals of democracy, patriotism, and peace.",
                                            "Be affectionate to the students and not behave in a vindictive manner towards any student for any reason.",
                                            "Pay attention for the attainment of the student in the assessment of merit.",
                                            "Make himself/herself available to the students even beyond their class hours to help and guide them without any remuneration or reward.",
                                            "Refrain from inciting students against other students, colleagues, or administration.",
                                        ].map((item, index) => (
                                            <div key={index} className="bg-white p-6">

                                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] text-[#D5AD57]">
                                                    {String(index + 1).padStart(2, "0")}
                                                </span>

                                                <p className="mt-4 text-[14px] leading-7 text-[#52606C]">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>

                                </article>


                                {/* 03 */}
                                <article id="colleagues" className="scroll-mt-[140px] grid overflow-hidden border border-[#071A2F]/10 bg-white lg:grid-cols-[.7fr_1.3fr]">

                                    <div className="bg-[#8B1E3F] p-8 text-white lg:p-10">

                                        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                            Section C
                                        </span>

                                        <strong className="mt-12 block font-['Libre_Caslon_Display',Georgia,serif] text-[72px] font-normal leading-none text-[#D5AD57]">
                                            03
                                        </strong>

                                        <h3 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[34px] font-normal leading-[1.1]">
                                            Teachers and Colleagues
                                        </h3>

                                    </div>

                                    <div className="p-8 lg:p-10">

                                        <h4 className="text-xs font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                            The teachers shall always:
                                        </h4>

                                        <ol className="mt-6 space-y-4">

                                            {[
                                                "Treat other members of the profession in an equitable and decent manner.",
                                                "Speak respect of other teachers and render assistance for professional betterment.",
                                                "Refrain from lodging unsubstantiated allegations against colleagues to higher authorities.",
                                                "Refrain from exploiting considerations of caste, creed, religion, race, or gender in their professional endeavor.",
                                                "Thorough social and humane, democratic and rational, towards other teachers.",
                                                "Strive at any cost to remove and wash out the local tensions and controversies and disputes.",
                                                "Believe in the unity of colleagues.",
                                            ].map((item, index) => (
                                                <li key={index} className="flex gap-4">

                                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#D5AD57]" />

                                                    <span className="text-[14px] leading-7 text-[#52606C]">
                                                        {item}
                                                    </span>

                                                </li>
                                            ))}

                                        </ol>

                                    </div>

                                </article>


                                {/* 04 */}
                                <article id="authorities" className="scroll-mt-[140px] border border-[#071A2F]/10 bg-[#F4E8EC] p-7 sm:p-9 lg:p-10">

                                    <div className="flex items-start justify-between gap-8">

                                        <div>

                                            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                Section D
                                            </span>

                                            <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[34px] font-normal text-[#071A2F]">
                                                Teachers and Authorities
                                            </h3>

                                        </div>

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[54px] text-[#D5AD57]">
                                            04
                                        </span>

                                    </div>

                                    <div className="mt-8 grid gap-4">

                                        {[
                                            "Discharge their professional responsibilities according to the existing rules and adhere to procedures and methods consistent with their profession in initiating steps through their university for change of any such rule detrimental to the professional interest.",
                                            "Not undertake any other employment and commitment including private tuition and coaching classes.",
                                            "Co-operate in the formulation of policies of the institution by accepting various offices and discharging responsibilities that such offices may demand.",
                                            "Co-operate with the authorities for the betterment of the institutions keeping in view the interest and in conformity with the dignity of the profession.",
                                            "Should adhere to the conditions of the contract.",
                                            "Give and expect due notice before a change of position is made.",
                                            "Refrain from availing themselves of leave except on unavoidable grounds and as far as practicable with prior intimation, keeping in view their particular responsibility for completion of the academic schedule.",
                                        ].map((item, index) => (
                                            <div key={index} className="grid gap-4 border-t border-[#071A2F]/10 pt-4 sm:grid-cols-[45px_1fr]">

                                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[20px] text-[#8B1E3F]">
                                                    {String(index + 1).padStart(2, "0")}
                                                </span>

                                                <p className="text-[14px] leading-7 text-[#52606C]">
                                                    {item}
                                                </p>

                                            </div>
                                        ))}

                                    </div>

                                </article>


                                {/* 05 + 06 */}
                                <div className="grid gap-6 md:grid-cols-2">

                                    <article id="non-teaching" className="scroll-mt-[140px] bg-[#071A2F] p-8 text-white">

                                        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                            Section E
                                        </span>

                                        <strong className="mt-8 block font-['Libre_Caslon_Display',Georgia,serif] text-[48px] font-normal text-[#D5AD57]">
                                            05
                                        </strong>

                                        <h3 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal leading-[1.15]">
                                            Teachers and Non-Teaching Employees
                                        </h3>

                                        <p className="mt-6 text-[14px] leading-7 text-white/65">
                                            The teachers should treat the non-teaching employees as colleagues with equality and fraternity.
                                        </p>

                                    </article>


                                    <article id="guardians" className="scroll-mt-[140px] bg-[#EEF4F8] p-8">

                                        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                            Section F
                                        </span>

                                        <strong className="mt-8 block font-['Libre_Caslon_Display',Georgia,serif] text-[48px] font-normal text-[#D5AD57]">
                                            06
                                        </strong>

                                        <h3 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal leading-[1.15] text-[#071A2F]">
                                            Teachers and Guardians
                                        </h3>

                                        <p className="mt-6 text-[14px] leading-7 text-[#52606C]">
                                            The teachers shall try to maintain contact with the guardians of their students, send a report of their performance to the guardians whenever necessary, and meet the guardians in meetings convened for mutual exchange of ideas and the benefit of the university.
                                        </p>

                                    </article>

                                </div>


                                {/* 07 */}
                                <article id="society" className="scroll-mt-[140px] border-y border-[#071A2F]/15 py-10">

                                    <div className="grid gap-8 lg:grid-cols-[280px_1fr]">

                                        <div>

                                            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                Section G
                                            </span>

                                            <strong className="mt-6 block font-['Libre_Caslon_Display',Georgia,serif] text-[70px] font-normal leading-none text-[#D5AD57]">
                                                07
                                            </strong>

                                            <h3 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[32px] font-normal text-[#071A2F]">
                                                Teachers and Society
                                            </h3>

                                        </div>

                                        <ol className="space-y-4">

                                            {[
                                                "Recognize that education is a public service and strive to keep the public informed of the educational programmes which are being provided.",
                                                "Work to improve education in the community and strengthen the community's moral and intellectual life.",
                                                "Be aware of social and economic problems and take part in such activities as would be conducive to the progress of society and hence the country as a whole.",
                                                "Perform the duties of citizenship, participate in community activities, and shoulder responsibilities of public office.",
                                                "Refrain from taking part in or subscribing to or assisting in any way, activities that tend to promote a feeling of hatred or enmity among communities, relations, or linguistic groups but actively work for national integration.",
                                            ].map((item, index) => (
                                                <li key={index} className="grid grid-cols-[40px_1fr] gap-4 border-b border-[#071A2F]/10 pb-4">

                                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[19px] text-[#D5AD57]">
                                                        {String(index + 1).padStart(2, "0")}
                                                    </span>

                                                    <span className="text-[14px] leading-7 text-[#52606C]">
                                                        {item}
                                                    </span>

                                                </li>
                                            ))}

                                        </ol>

                                    </div>

                                </article>


                                {/* 08 */}
                                <article id="additional" className="scroll-mt-[140px] bg-[#071A2F] p-7 text-white sm:p-9 lg:p-10">

                                    <div className="grid gap-10 lg:grid-cols-[300px_1fr]">

                                        <div>

                                            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                                Additional Guidelines
                                            </span>

                                            <strong className="mt-6 block font-['Libre_Caslon_Display',Georgia,serif] text-[70px] font-normal leading-none text-[#D5AD57]">
                                                08
                                            </strong>

                                            <h3 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[34px] font-normal leading-[1.12]">
                                                Additional Conduct Responsibilities
                                            </h3>

                                        </div>


                                        <ol className="space-y-4">

                                            {[
                                                "Maintain the highest standards of discipline and dignified manner of behaviour inside as well as outside the university campus. They shall abide by the rules and regulations of the university and should act in a way that highlights the discipline and esteem of the institute.",
                                                "Work in the time schedule from Monday to Friday is followed. Classes are scheduled from 9.15 a.m. to 3.00 p.m. All the students are expected to be present in the class well - within time and late coming will attract a loss of attendance for the corresponding hour.",
                                                "Encourage student seminars/workshops/webinars/project presentations etc., all the students of the concerned class must be present for the entire session.",
                                                "Permit students in case of sickness or other valid grounds requires a gate pass with an application duly forwarded by the HOD and Dean. Application for medical leave shall be accompanied by valid medical fitness certificate of the treating Doctor while resuming classes after illness.",
                                                "Advise to refrain from activities such as scribbling or noting on student desks, doors, or other furniture which could deface the university and destroy the academic ambiance.",
                                                "Advise students to handle the chemicals, apparatus, equipment, fixtures and appliances carefully of the laboratories/workshops of the university. Careless handling/misuse of the above could result in personal injuries or damage to property. Follow safety precautions near moving machines and electrical installations. In the event of property damage, the responsible students will have to bear the cost of replacement/repair with a fine.",
                                                "Students are not allowed to arrange any unauthorized celebrations and decorations of any magnitude in the campus.",
                                                "Students are not allowed to distribute or display (both physically and electronically) material such as notices or banners etc. in the campus without the permission of the competent authority.",
                                                "Initiate action in case of non-compliance the code of conduct means for students or any observed matter/behaviour that deviates from the vision and mission of the code of conduct, all the faculty members are empowered to initiate the disciplinary procedure by filling in a standard form which in turn may lead to the constitution of an inquiry committee for further proceedings.",
                                            ].map((item, index) => (
                                                <li key={index} className="grid gap-4 border-b border-white/10 pb-4 sm:grid-cols-[45px_1fr]">

                                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[20px] text-[#D5AD57]">
                                                        {String(index + 1).padStart(2, "0")}
                                                    </span>

                                                    <span className="text-[14px] leading-7 text-white/65">
                                                        {item}
                                                    </span>

                                                </li>
                                            ))}

                                        </ol>

                                    </div>

                                </article>

                            </div>

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}